import React from 'react'

function Settings() {
  return (
    <div>Tämä välilehti ei ole vielä käytössä.</div>
  )
}

export default Settings